import RelatorioListarTurmaPage from "@/Pages/Relatorios/ListarTurmaPage.vue";
import lancarRelatorioBNCCPage from "@/Pages/Relatorios/lancarRelatorioBNCCPage.vue";
import relatorioPage from "@/Pages/Relatorios/index.vue";
import { can } from "@/plugins/can";

const checkPermission = (permissions) => {
  return (to, from, next) => {
    if (!can(permissions)) {
      return next({ name: "NaoAutorizado" });
    }
    return next();
  };
};

export default [
  {
    path: "/relatorios/:franquiaId",
    name: "relatorios",
    component: relatorioPage,
    beforeEnter: checkPermission(["relatorios.*"]),
  },
  {
    path: "/relatorios/visualizar/:gestaoDeAulasId/:turmaId",
    name: "relatorios.visualizar",
    component: RelatorioListarTurmaPage,
  },
  {
    path: "/relatorios/lancarRelatorioBNCC/:matricula_id",
    name: "relatorios.lancarRelatorioBNCC",
    component: lancarRelatorioBNCCPage,
  },
];
